import { Container, Typography } from "@material-ui/core";
import React from "react";

const ErrorPage = () => {
	return (
		<Container
			style={{
				height: "calc(100vh - 64px)",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				textAlign: "center",
			}}
		>
			<Typography variant="h2">PAGE NOT FOUND</Typography>
		</Container>
	);
};

export default ErrorPage;
